// API配置管理
// 开发环境默认走Vite代理，避免跨域与Cookie问题
const _defaultTaskMgr = '/task_manager';

export const API_CONFIG = {
  // 任务管理系统API地址 - 完全依赖环境变量，开发环境使用相对路径
  TASK_MANAGER_BASE: (
    import.meta.env.VITE_TASK_MANAGER_URL || _defaultTaskMgr
  ).replace(/\/$/, ''),
  
  // 超时时间配置
  TIMEOUT: {
    DEFAULT: 30000, // 30秒
    LONG: 1200000,  // 20分钟
  },
  
  // 重试配置
  RETRY: {
    MAX_RETRIES: 3,
    RETRY_DELAY: 1000, // 1秒
  }
};

// 日志配置
export const LOG_CONFIG = {
  LEVEL: {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3
  },
  ENABLED: true
};